import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) =>
  value && moment(value).isValid() ? moment(value).format('DD MMMM YYYY') : '—';

const displayStatus = (status, t) => {
  if (status === 'active') {
    return t('Attiva');
  }
  if (status === 'inactive') {
    return t('Disattiva');
  }
  return display(status);
};

export const getLeasingContactViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const visitCard = item?.allData?.visit_card;

  const fields = [
    { text: t('Nome'), value: display(item.name) },
    { text: t('Cognome'), value: display(item.surname) },
    {
      text: t('Ruolo'),
      value: display(item.leasings_contact_role),
    },
    { text: t('Nome azienda'), value: display(item.company_title) },
    {
      text: t('Data primo incontro'),
      value: displayDate(item.first_visit_date),
    },
    { text: t('Mail'), value: display(item.email) },
    { text: t('Cellulare'), value: display(item.cellphone) },
    { text: t('Numero ufficio'), value: display(item.phone) },
    { text: t('Indirizzo azienda'), value: display(item.company_address) },
    {
      text: t('Leasing manager di riferimento'),
      value: display(item.leasings_manager?.name),
    },
    {
      text: t('Stato contatto'),
      value: displayStatus(item.status, t),
    },
    {
      text: t('Numero unità proposte'),
      value: display(item.rooms_proposet),
    },
    {
      text: t('Data ultimo contatto'),
      value: displayDate(item.lasttime_contact_date),
    },
  ];

  if (visitCard?.id) {
    fields.push({
      text: t('Riferimento ultimo contatto'),
      value: (
        <Link to={`/leasing/visit_card/${visitCard.id}/edit`}>
          {visitCard.title || t('Riferimento ultimo contatto')}
        </Link>
      ),
    });
  }

  return [
    {
      title: t('Info'),
      fields,
    },
  ];
};
